import { Box, BoxProps } from "@hightouch/htui";

export const Icon = (props: BoxProps) => (
  <Box
    as="svg"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <Box
      as="path"
      fillRule="evenodd"
      d="M13 3C13.5523 3 14 3.44771 14 4C14 4.55224 13.5523 5 13 5H6C5.44772 5 5 5.44771 5 6V18C5.00004 18.5523 5.44775 19 6 19H7.09961C7.56288 16.7177 9.58104 15 12 15C14.419 15 16.4371 16.7177 16.9004 19H18C18.5523 19 19 18.5523 19 18V10C19 9.4477 19.4477 9 20 9C20.5523 9 21 9.4477 21 10V18C21 19.6568 19.6569 21 18 21H6C4.34318 21 3.00004 19.6568 3 18V6C3 4.34314 4.34315 3 6 3H13ZM12 17C10.6938 17 9.58273 17.8348 9.1709 19H14.8291C14.4173 17.8348 13.3062 17 12 17ZM12 7C13.933 7 15.5 8.56699 15.5 10.5C15.5 12.433 13.933 14 12 14C10.067 14 8.50004 12.433 8.5 10.5C8.5 8.56699 10.067 7 12 7ZM12 9C11.1716 9 10.5 9.67156 10.5 10.5C10.5 11.3284 11.1716 12 12 12C12.8284 12 13.5 11.3284 13.5 10.5C13.5 9.67156 12.8284 9 12 9ZM18.3311 1.53906C18.4861 0.820228 19.5127 0.820397 19.668 1.53906L19.7441 1.8916C19.8909 2.57477 20.4244 3.10882 21.1074 3.25586L21.46 3.33105C22.1796 3.48581 22.1796 4.51321 21.46 4.66797L21.1074 4.74414C20.4245 4.89111 19.8911 5.42455 19.7441 6.10742L19.668 6.45996C19.5132 7.17958 18.4858 7.17959 18.3311 6.45996L18.2559 6.10742C18.1088 5.42437 17.5748 4.89091 16.8916 4.74414L16.5391 4.66797C15.8204 4.51267 15.8202 3.48613 16.5391 3.33105L16.8916 3.25586C17.575 3.10903 18.109 2.575 18.2559 1.8916L18.3311 1.53906Z"
      clipRule="evenodd"
    />
  </Box>
);
